<template>
<div class="group-config">
  <el-card shadow="never">
    <div class="btn-header">
      <el-button type="primary" @click="addGroup()">添加分组</el-button>
    </div>
    <div class="custom-tree-container">
      <el-tree :data="groupList" show-checkbox node-key="id" default-expand-all :expand-on-click-node="false" :props="defaultProps">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <span class="operationBtns">
            <el-button v-if="data.projectId==''" type="text" size="mini" @click="() => importProject(data)">
              导入项目
            </el-button>
            <el-button v-if="data.projectId==''" type="text" size="mini" @click="() => append(data)">
              添加子组
            </el-button>
            <el-button type="text" size="mini" @click="() => remove(node, data)">
              删除
            </el-button>
          </span>
        </span>
      </el-tree>
    </div>
  </el-card>
  <el-dialog title="添加组织" :visible.sync="groupDialogVisible" width="30%">
    <span>组织名称：</span>
    <el-input v-model="groupName" style="width: 200px;"></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="groupDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitAddGroup()">确 定</el-button>
    </span>
  </el-dialog>
  <el-dialog title="导入项目" :visible.sync="projectDialogVisible" width="30%">
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
    <el-tree class="filter-tree" :data="projectList" show-checkbox node-key="id" default-expand-all :filter-node-method="filterNode" ref="tree">
    </el-tree>
    <span slot="footer" class="dialog-footer">
      <el-button @click="projectDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="importGroupProjectTree()">确 定</el-button>
    </span>
  </el-dialog>
  <el-dialog title="添加子组" :visible.sync="dialogVisible" width="30%">
    <span>子组织名称：</span>
    <el-input v-model="childGroupName" style="width: 200px;"></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitChildGroup()">确 定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
let id = 1000;
import GROUPAPI from '@/api/group';
import COMMONAPI from '@/api/common';
export default {
  props: {
    groupId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      groupList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      groupDialogVisible: false,
      groupName: '',
      projectDialogVisible: false,
      dialogVisible: false,
      childGroupName: '',
      filterText: '',
      projectList: [],
      currGroupTreeId: ""
    };
  },
  created() {
    this.searchGroupProjectTreeList();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    searchGroupProjectTreeList() {
      let params = {
        groupId: this.groupId
      };
      GROUPAPI.searchGroupProjectTreeList(params).then(res => {
        if (res.data.code == 200) {
          this.groupList = res.data.data;
        }
      });
    },
    addGroup() {
      this.groupDialogVisible = true;
    },
    submitAddGroup() {
      let params = {
        groupId: this.groupId,
        name: this.groupName,
        pid: 0,
        projectId: ""
      };
      GROUPAPI.addGroupProjectTree(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('添加成功!');
          this.searchGroupProjectTreeList();
          this.groupDialogVisible = false;
        }
      });
    },
    importProject(data) {
      this.currGroupTreeId = data.id;
      this.projectDialogVisible = true;
      this.searchProjectByGroup();
    },
    searchProjectByGroup() {
      let params = {
        groupId: this.groupId
      };
      this.projectList = [];
      GROUPAPI.searchProjectByGroup(params).then(res => {
        if (res.data.code == 200) {
          let projectList = res.data.data;
          projectList.forEach(e => {
            this.projectList.push({
              id: e.projectId,
              label: e.projectName
            })
          });
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    importGroupProjectTree() {
      let projectIds = this.$refs.tree.getCheckedKeys();
      let params = {
        groupId: this.groupId,
        groupTreeId: this.currGroupTreeId,
        projectIds: projectIds
      };
      GROUPAPI.importGroupProjectTree(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('导入成功!');
          this.searchGroupProjectTreeList();
          this.projectDialogVisible = false;
        }
      });
    },
    append(data) {
      this.dialogVisible = true;
      this.childGroupName = "";
      this.currGroup = data;
    },
    submitChildGroup() {
      let params = {
        groupId: this.groupId,
        name: this.childGroupName,
        pid: this.currGroup.id,
        projectId: ""
      };
      GROUPAPI.addGroupProjectTree(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('添加成功!');
          this.searchGroupProjectTreeList();
          this.dialogVisible = false;
        }
      });
    },
    remove(node, data) {
      this.$confirm('确定删除此节点吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteGroupProjectTree(data.id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      // const parent = node.parent;
      // const children = parent.data.children || parent.data;
      // const index = children.findIndex(d => d.id === data.id);
      // children.splice(index, 1);
    },
    deleteGroupProjectTree(id) {
      let params = {
        groupTreeId: id
      };
      GROUPAPI.deleteGroupProjectTree(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('删除成功!');
          this.searchGroupProjectTreeList();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.group-config {
  width: 70%;
  margin: 20px auto;

  .btn-header {
    margin-bottom: 20px;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 100px;
  }

  .operationBtns {
    float: right;
  }

  .btn-footer {
    margin: 20px;
    text-align: center;
  }

  .filter-tree {
    margin-top: 20px;
  }
  .custom-tree-container{
    .el-tree{
      height:60vh;
      overflow:auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/group/groupConfig.vue